const LOAD_MACHINE_METRICS_ALARM_HISTORY = 'MACHINES_METRICS/LOAD_ALARM_HISTORY';

export { LOAD_MACHINE_METRICS_ALARM_HISTORY };
